/**
 * 스타일드 컴포넌트를 위한 테마 정의
 * Tailwind 설정 차이에 영향받지 않는 일관된 스타일 제공
 */ // 라이트 테마
export var lightTheme = {
    background: '#ffffff',
    foreground: '#000000',
    paper: '#ffffff',
    paperLight: '#f9fafb',
    paperHover: '#f3f4f6',
    paperActive: '#e5e7eb',
    paperDark: '#d1d5db',
    border: '#e5e7eb',
    borderLight: '#f3f4f6',
    text: '#111827',
    textSecondary: '#4b5563',
    textMuted: '#6b7280',
    primary: '#3b82f6',
    primaryLight: '#60a5fa',
    primaryDark: '#2563eb',
    primaryText: '#ffffff',
    secondary: '#6b7280',
    secondaryLight: '#9ca3af',
    secondaryDark: '#4b5563',
    secondaryText: '#ffffff',
    shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    shadows: {
        sm: '0 1px 3px rgba(0,0,0,0.1)'
    },
    breakpoints: {
        sm: '640px',
        md: '768px',
        lg: '1280px',
        xl: '1536px'
    },
    spacing: {
        xs: '0.25rem',
        sm: '0.5rem',
        md: '1rem',
        lg: '1.5rem',
        xl: '2rem',
        xxl: '3rem'
    },
    typography: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontSize: {
            xs: '0.75rem',
            sm: '0.875rem',
            base: '1rem',
            lg: '1.125rem',
            xl: '1.25rem',
            xxl: '1.5rem'
        },
        fontWeight: {
            normal: 400,
            medium: 500,
            semibold: 600,
            bold: 700
        }
    },
    radius: {
        sm: '0.25rem',
        md: '0.5rem',
        lg: '1rem',
        full: '9999px'
    },
    transition: {
        fast: '150ms ease',
        normal: '300ms ease',
        slow: '500ms ease'
    },
    error: '#EF4444',
    errorBg: '#f8d7da',
    success: '#10B981',
    warning: '#F59E0B',
    info: '#3B82F6',
    isDark: false
};
// 다크 테마
export var darkTheme = {
    background: '#111827',
    foreground: '#f9fafb',
    paper: '#1f2937',
    paperLight: '#374151',
    paperHover: '#374151',
    paperActive: '#4b5563',
    paperDark: '#6b7280',
    border: '#374151',
    borderLight: '#4b5563',
    text: '#f9fafb',
    textSecondary: '#e5e7eb',
    textMuted: '#9ca3af',
    primary: '#60a5fa',
    primaryLight: '#93c5fd',
    primaryDark: '#3b82f6',
    primaryText: '#ffffff',
    secondary: '#9ca3af',
    secondaryLight: '#d1d5db',
    secondaryDark: '#6b7280',
    secondaryText: '#ffffff',
    shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2)',
    shadows: {
        sm: '0 1px 3px rgba(0,0,0,0.2)'
    },
    breakpoints: {
        sm: '640px',
        md: '768px',
        lg: '1280px',
        xl: '1536px'
    },
    spacing: {
        xs: '0.25rem',
        sm: '0.5rem',
        md: '1rem',
        lg: '1.5rem',
        xl: '2rem',
        xxl: '3rem'
    },
    typography: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontSize: {
            xs: '0.75rem',
            sm: '0.875rem',
            base: '1rem',
            lg: '1.125rem',
            xl: '1.25rem',
            xxl: '1.5rem'
        },
        fontWeight: {
            normal: 400,
            medium: 500,
            semibold: 600,
            bold: 700
        }
    },
    radius: {
        sm: '0.25rem',
        md: '0.5rem',
        lg: '1rem',
        full: '9999px'
    },
    transition: {
        fast: '150ms ease',
        normal: '300ms ease',
        slow: '500ms ease'
    },
    error: '#EF4444',
    errorBg: 'rgba(239, 68, 68, 0.2)',
    success: '#10B981',
    warning: '#F59E0B',
    info: '#3B82F6',
    isDark: true
};
